import React, { useEffect, useState } from 'react';
import './SearchBox.scss';
import SearchIcon from '@mui/icons-material/Search';
import { usePlaywatchKids } from './Context';

interface SearchBoxProps {
    hide?: boolean;
    onFocusChange: (isFocused) => void;
    onSearch: (query: string) => void; // Callback for when a search is executed
}

const SearchBox: React.FC<SearchBoxProps> = ({ hide, onSearch, onFocusChange }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [focus, setFocus] = useState(false);
    const { setFocusFunc, clearSearchCallback } = usePlaywatchKids();

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
    };

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        onSearch(searchTerm);
    };
    useEffect(() => {
        setFocusFunc(() => (v) => {
            setFocus(v);
            if (setFocus) {
                let textBox: any = document.querySelector('#search-text-box')
                if (textBox) {
                    textBox.focus();
                }
            }
        })
        clearSearchCallback(() => {
            setSearchTerm('');
        })
    }, [])
    useEffect(() => {
        onFocusChange(focus);
    }, [focus])

    return (
        <div style={{ display: hide ? 'none' : '' }} className={`pwk-search-box-container ${focus ? 'focus' : ''}`}>
            <div className="pwk-search-box">
                <form onSubmit={handleSubmit} className="search-box">
                    <input
                        type="text"
                        id={'search-text-box'}
                        value={searchTerm}
                        onChange={handleChange}
                        onFocus={() => {
                            setFocus(true)
                        }}
                        onBlur={() => {
                            setFocus(false);
                        }}
                        placeholder="Search..."
                        className="search-input"
                    />
                    <div className="search-icon-container">
                        <button type="submit" className="search-button">
                            <SearchIcon className='search-icon' fontSize='large' />
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default SearchBox;
